<template>
  <div class="user-container" ref="usercontainer">
    <el-row class="user-button">
      <el-button type="primary" @click="dialogAddFormVisible = true"><i class="el-icon-plus"></i>新增文物</el-button>
    </el-row>

    <template>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="精品文物" name="first">
          <el-row>
            <el-col :span="4" v-for="item in displayList" :key="item.index" style="margin: 0 0 20px;">
              <div class="grid-content bg-purple" style="padding:0 10px;">
                <img :src="item.imgsrc" style="width: 100%;">
                <h4>{{item.title}}</h4>
                <p style="text-align: right">
                  <el-button size="mini" type="primary" icon="el-icon-edit" @click="openUpdate(item.id)"></el-button>
                  <el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteData(item)"> </el-button>
                </p>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>

        <el-tab-pane label="国防教育" name="second">
          <el-row>
            <el-col :span="4" v-for="item in displayList" :key="item.index" style="margin: 0 0 20px;">
              <div class="grid-content bg-purple" style="padding:0 10px;">
                <img :src="item.imgsrc" style="width: 100%;">
                <h4>{{item.title}}</h4>
                <p style="text-align: right">
                  <el-button size="mini" type="primary" icon="el-icon-edit" @click="openUpdate(item.id)"></el-button>
                  <el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteData(item)"></el-button>
                </p>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>

      </el-tabs>
    </template>

    <!--新增展陈-->
    <!-- Form -->
    <el-dialog title="新增文物" :visible.sync="dialogAddFormVisible">
      <el-form :model="addForm" style="text-align: left">
        <el-form-item label="文物标题" :label-width="formLabelWidth">

          <el-input v-model="addForm.title" autocomplete="off"></el-input>

        </el-form-item>
        <el-form-item label="文物图片"  :label-width="formLabelWidth">

          <el-upload
              ref="upload"
              action="/api/common/upload"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-success="handSuccess"
              list-type="picture-card"
          >
            <i class="el-icon-plus"></i>
          </el-upload>

          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>

        </el-form-item>



        <el-form-item label="所属类别" :label-width="formLabelWidth" style="width:60%">
          <el-select v-model="addForm.columnId" placeholder="请选择所属类别" >
            <el-option label="精品文物" value=1></el-option>
            <el-option label="国防教育" value=2></el-option>
          </el-select>
        </el-form-item>



        <el-form-item label="排序" :label-width="formLabelWidth">
          <el-input v-model="addForm.sort" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>



      <div slot="footer" class="dialog-footer">
        <el-button @click="offPage()">取 消</el-button>
        <el-button type="primary" @click="addSubmit(addForm)">确 定</el-button>
      </div>



    </el-dialog>
    <!-- Form -->

    <!--修改-->
    <el-dialog title="文物修改" :visible.sync="dialogUpdateFormVisible">
      <el-form :model="updateForm" style="text-align: left">
        <el-form-item label="文物标题" :label-width="formLabelWidth">
          <el-input v-model="updateForm.title" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="文物图片"  :label-width="formLabelWidth">
          <div style="float: left" v-if="imgVisible">
            <div class="el-upload-list el-upload-list--picture-card">
              <div class="el-upload-list__item is-success">
                <img :src="updateForm.imgsrc" style="width:100%;height: 100%">
                <span class="el-upload-list__item-actions" >
                  <span class="el-upload-list__item-preview" @click="deleteImg()" >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </div>
          </div>


          <el-upload
              action="/api/common/upload"

              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-success="handSuccess"
              list-type="picture-card"
              :limit = 1
              :multiple = false
              v-if="imgUploadVisible"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
<!--          <el-dialog :visible.sync="dialogVisible">-->
<!--            <img width="100%" :src="dialogImageUrl" alt="">-->
<!--          </el-dialog>-->
        </el-form-item>

        <el-form-item label="排序" :label-width="formLabelWidth">
          <el-input v-model="updateForm.sort" autocomplete="off"></el-input>
        </el-form-item>



      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogUpdateFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="upDateAdd(updateForm)">确 定</el-button>
      </div>
    </el-dialog>

    <!--修改-->


  </div>
</template>

<script>
import {request} from "@/request/request";

export default {
  name: "CulturalAdmin",
  data(){
    return{
      dialogAddFormVisible:false,
      activeName: 'first',
      formLabelWidth:'120px',
      dialogImageUrl: '',
      dialogVisible: false,
      restfulUrl:'cultural',
      dialogUpdateFormVisible:false,
      imgVisible:false,
      imgUploadVisible:false,
      addForm:{
        title:'',
        imgsrc:'',
        columnId:'',
        sort:1
      },
      updateForm:{
        title:'',
        imgsrc:'',
        sort:''
      },
      displayList:[]
    }
  },
  methods:{
    handleClick(tab) {
      var columnData = parseInt(tab.index)+1;
      this.getDataByColumn({columnId:columnData})
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      console.log(file)
    },
    handSuccess(response){
      this.addForm.imgsrc = response.data;
      this.updateForm.imgsrc = response.data;
      this.imgUploadVisible = false;
      this.imgVisible = true;
    },
    deleteImg:function(){
      this.imgVisible = false;
      this.imgUploadVisible = true;
      this.updateForm.imgsrc = '';
    },
    openUpdate(uid){
      console.log(uid)
      this.updateForm.id = uid;
      this.dialogUpdateFormVisible = true;
      request({
        method:'GET',
        url:this.restfulUrl+'/'+uid,
      }).then(res =>{
        console.log(res)
        if(res.code==1){
          this.updateForm = res.data;
        }
        if(res.data.imgsrc){
          this.imgVisible = true;
        }
      },err=>{
        console.log(err)
      })
    },
    addSubmit(data){
      if(!this.addForm.title){
        console.log("请输入标题")
        return false
      }
      if(!this.addForm.columnId){
        console.log("请输入类别")
        return false
      }
      if(!this.addForm.imgsrc){
        console.log("请上传图片")
        return false
      }
      data.columnId = parseInt(data.columnId);
      data.sort = parseInt(data.sort);
      request({
        method:'POST',
        url:'/cultural',
        data:data
      }).then(res =>{
        console.log(res)
        this.getDataByColumn({columnId:data.columnId});
        this.dialogAddFormVisible = false;
        if(data.columnId == 1){
          this.activeName = 'first';
        }
        else{
          this.activeName = 'second'
        }

        this.$message({
          type: 'success',
          message: '新增成功!',
        });

        this.addForm = {
              title:'',
              imgsrc:'',
              columnId:'',
              sort:1
        };

        this.$refs.upload.clearFiles();

      },err=>{
        console.log(err)
      })

      console.log(data)
    },
    offPage(){
      this.dialogAddFormVisible = false;
      this.addForm={title:'', imgsrc:'', columnId:'',sort:1};

    },
    getDataByColumn(data){
      request({
        method:'POST',
        url:'/cultural/getcolumn',
        data:data
      }).then(res =>{
        console.log(res)
        this.displayList = res.data
      },err=>{
        console.log(err)
      })
    },
    deleteData(data){
      this.$confirm('此操作将永久删除该, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        //删除用户请求
        this.deleteById(data);

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    deleteById:function(uid){
      request({
        method:'DELETE',
        url:this.restfulUrl+'/'+uid.id,
      }).then(res =>{
        if(res.code==1){
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          this.getDataByColumn({columnId:uid.columnId});
        }
      },err=>{
        console.log(err)
      })
    },
    upDateAdd:function(formData){
      request({
        method:'PUT',
        url:'/cultural',
        data:formData
      }).then(res =>{
        if(res.code==1){
          this.$message({
            type: 'success',
            message: '修改成功!',
          });
          this.dialogUpdateFormVisible = false;
          this.getDataByColumn({columnId:formData.columnId})
        }
      },err=>{
        console.log(err)
      })
      this.dialogFormVisible = false;
    },
  },
  mounted() {
    this.getDataByColumn({columnId:1});

  }
}
</script>

<style scoped>
.user-button{
  text-align: left;
  padding:0 10px 10px;
  border-bottom: 1px solid rgb(165,165,165);
}
.user-container{
  height:100%;
}
.user-con{
  padding:40px;
}

.grid-content img{
  width:100%;
  height:200px;
}

.grid-content h4{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>
